module.exports = __webpack_public_path__ + "static/media/lock-icon.570f3584.svg";